import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        display: flex;
        flex-direction: row;
    `,
    Main: styled("div")`
        display: flex;
        flex: 1;
        flex-direction: column;
        background-color: #fff;
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
        border-top-left-radius: 12px;
    `,
};
